import {
  Button,
  Card,
  Flex,
  Heading,
  HStack,
  Stack,
  Tooltip,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import Layout from "../Layout/Layout";
import FilterListByToolType from "./FilterListByToolType";
import SearchInput from "./SearchInput";
import ToolsList from "./ToolsList";
import ToolsNotFound from "./ToolsNotFound";
import ToolsTourGuide from "./ToolsTourGuide";
import useFilterTool from "./useFilterTool";
import useTools from "./useTools";
import Loader from "../../utils/Loader/Loader";
import AddToolModal from "./AddEditToolModal";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { useContext } from "react";
import { SettingContext } from "../Settings/Reducer/SettingProvider";
export default function Tools() {
  const { isOpen, onClose } = useDisclosure({
    defaultIsOpen: localStorage.getItem("toolsTourVisibility") ? false : true,
  });

  const {
    isOpen: isAddToolOpen,
    onOpen: addToolOpen,
    onClose: addToolClose,
  } = useDisclosure();

  const onCloseTour = () => {
    localStorage.setItem("toolsTourVisibility", true);
    onClose();
  };
  const { toolsList, toolsTypes, status, getToolList } = useTools();

  const loading = status === "loading";
  const filter = useFilterTool();

  const filteredTools = toolsList.filter(
    (tool) =>
      (filter.typeOfTool === "all" || filter.typeOfTool === tool.category) &&
      (!filter.search ||
        tool.name
          .toLocaleLowerCase()
          .includes(filter.search.toLocaleLowerCase()))
  );
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme } = agency;
  const { state } = useContext(SettingContext);
  const disableAddCustomTool = (state?.credits?.custom_tool || 0) <= 0;

  return (
    <>
    <VStack h="100%" spacing={2} borderRadius="md">
        <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
          <Flex gap={2} w={"100%"} alignItems="center" py={2}>
            <Heading color={textColor} fontSize="xl">
              {"Tools"}
            </Heading>
            {isOpen ? <ToolsTourGuide onCloseTour={onCloseTour} /> : null}
          </Flex>

          {loading ? (
            <Loader />
          ) : (
            <HStack height={"100%"} spacing={3} overflowY={"auto"} p={1}>
              <Card
                variant={"elevated"}
                p={4}
                h={"100%"}
                overflowY={"auto"}
                w={"200px"}
              >
                <FilterListByToolType
                  toolsList={toolsList}
                  toolTypes={toolsTypes}
                  search={filter.search}
                  selectedToolType={filter.typeOfTool}
                  onSetTypeOfTool={filter.onSetTypeOfTool}
                />
              </Card>

              <Card
                p={4}
                variant={"elevated"}
                h={"100%"}
                overflowY={"auto"}
                flex={1}
              >
                <Stack spacing={2} gap={4} height={"100%"} overflowY={"auto"}>
                  <Flex justifyContent={"space-between"} gap={4}>
                    <SearchInput {...filter} />
                    <Tooltip label={disableAddCustomTool && "Not available"}>
                      <Button
                        isDisabled={disableAddCustomTool}
                        colorScheme={buttonColorScheme}
                        onClick={addToolOpen}
                        px={"40px"}
                      >
                        Add a Custom Tool
                      </Button>
                    </Tooltip>
                  </Flex>
                  {filteredTools.length ? (
                    <ToolsList
                      filteredTools={filteredTools}
                      getToolList={getToolList}
                    />
                  ) : (
                    <ToolsNotFound />
                  )}
                </Stack>
              </Card>
            </HStack>
          )}
        </Flex>
      </VStack>

      {isAddToolOpen && (
        <AddToolModal
          isOpen={isAddToolOpen}
          onClose={addToolClose}
          refreshToolList={getToolList}
        />
      )}
    </>
      
  );
}
